<template>
  <div class="home page-container" >
    <div class="index_ad">
      <!-- <div class="ad_text">
        <span class="hidden-xs-only ">{{ $t('bannerDelieveryMessage') }}</span>
        <small class="hidden-xs-only ">({{ $t('bannerDelieveryLocation') }})</small>
        <span class="mobile_text hidden-sm-and-up">
          <span>{{ $t('bannerDelieveryMessage') }}</span>({{ $t('bannerDelieveryLocation') }})
        </span>
      </div> -->
    </div>

    <!--banner-->
    <div class="banner">
      <swiper :options="bannerSwiper">
        <swiper-slide v-for="(item,index) in filterBillboard(this.$store.state.billboard.billboardImages, $i18n.locale)" data-index="index" :key="index">
          <div v-if="item.URL">
            <a :href="item.URL"><img class='swiImg' :src='item.Image'/></a>
          </div>
          <div v-else ><img class='swiImg' :src='item.Image'/></div>
        </swiper-slide>
      </swiper>
      <!-- <div class="banner-button-prev"></div>
      <div class="banner-button-next"></div> -->
    </div>
    <!--end banner-->
    
    <!--main-->
    <div class="Bestsellers">
      <div class="page-width">
        <!--services-->
        <!-- <div class="padding">
          <div class="text-center">
            <h2>{{ $t('ourServices') }}</h2>
          </div>
          <ul class="function" >
            <li v-for="(item, index) in functionSlides" data-index="index" :key="index">
              <img class="howImg" :src="item.img" alt=""/>
              <button class="howBtn" @click="goTo(index)"><span>{{ $t(item.btn) }}</span></button>
            </li>
          </ul>
        </div> -->
      </div>
      <!--end services-->
    </div>
    <!--end main-->
    
    <!--review-->
    <!-- <div class="review">
      <div class="page-width">
        <span class="title">Don't Just Take Our Words</span>
        <ul class="reviews">
          <li><img class="img" src="../assets/img/review1.png" alt=""/></li>
          <li><img class="img" src="../assets/img/review2.png" alt=""/></li>
          <li><img class="img" src="../assets/img/review3.png" alt=""/></li>
        </ul>
      </div>
    </div> -->
    <!--end clients-->
    
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import $ from 'jquery';
export default {
  name: "home",
  data() {
    return {
      // swiper api：https://www.swiper.com.cn/api/index.html (https://swiperjs.com/)
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      functionSlides: [
        {
          img: require('../assets/img/step_2.png'),
          title: "inbound",
          btn: "createInbound",
        },  {
          img: require('../assets/img/step_1.png'),
          title: "outboundInv",
          btn: "createOutboundInv",
        }, {
        //   img: require('../assets/img/step_2.png'),
        //   title: "mso",
        //   btn: "importmso",
        // }, {
        //   img: require('../assets/img/step_1.png'),
        //   title: "outboundXPO",
        //   btn: "createOutboundXPO", // createOutboundXPO
        // }, {
          img: require('../assets/img/step_1.png'),
          title: "outboundXPONoInv",
          btn: "createOutboundNoInv", // createOutboundXPO
        },
      ],
      flushBbottom: {
        slidesPerView: 1,
      },
      homeImgLeft: true,
    }
  },
  methods:{
    goTo(index) {
      // go to place order
      if (index === 0) {
        this.$router.push('/inbound');
      } else if (index === 1) {
        this.$router.push('/outboundInv');
      // } else if (index === 2) {
      //   this.$router.push('/mso');
      // } else if (index === 3) {
      //   this.$router.push('/outboundXPO');
      } else if (index === 2 ) {
        this.$router.push('/outboundXPONoInv');
      } 
    },
    homeImgCountChange() {
      this.homeImgLeft = !this.homeImgLeft;
      return true;
    },
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      // let filterBillboard = [];
      // filterBillboard.push("https://www.birlasoft.com/sites/default/files/banner-h-oracle-logistics.jpg");
      return filterBillboard;
    },
  },
  computed: mapState ({
    token: state => state.auth.token,
    loggedIn: state => state.auth.loggedIn,
  }),
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
    // this.$store.dispatch('products/fetchCustomCategories');
  },
  watch: {
  },
}
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/home.vue